import { render } from "./DocumentClassExportInterfaceSubView.vue?vue&type=template&id=65639b27&scoped=true&ts=true"
import script from "./DocumentClassExportInterfaceSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassExportInterfaceSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassExportInterfaceSubView.vue?vue&type=style&index=0&id=65639b27&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65639b27"]])

export default __exports__